const TYPE_APP = "@global"

const contextTypes = {
  SIGN_IN: `${TYPE_APP}/SIGN_IN`,
  SIGN_OUT: `${TYPE_APP}/SIGN_OUT`,
};

export default contextTypes;
